jQuery(function($){
    var el = $('.site-header__search');
    // check for site-search--in-page, do not show header search
    //if ($('.site-search--in-page').length) return;
    el.show();
    $('.site-header__search-toggle', el).on('click', function(e){
        if (el.hasClass('on')) {
            el.removeClass('on').addClass('off');
        } else {
            el.removeClass('off').addClass('on');
            document.getElementById('s').focus();
        }
    });
    // remove term from search form in the header
    el.find('[name="s"]').val('');
});
